import type { ReactElement } from 'react';
import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Headphones(props: IconSvgProps): ReactElement {
  return (
    <BaseLibraryIconSvg {...props} viewBox='0 0 56 56'>
      <path
        d='M49.3281 27.9998H42.3281C41.3999 27.9998 40.5096 28.3685 39.8533 29.0249C39.1969 29.6813 38.8281 30.5715 38.8281 31.4998V40.2498C38.8281 41.178 39.1969 42.0682 39.8533 42.7246C40.5096 43.381 41.3999 43.7498 42.3281 43.7498H45.8281C46.7564 43.7498 47.6466 43.381 48.303 42.7246C48.9594 42.0682 49.3281 41.178 49.3281 40.2498V27.9998ZM49.3281 27.9998C49.3282 25.2272 48.7793 22.4821 47.713 19.9228C46.6467 17.3635 45.0842 15.0406 43.1156 13.0883C41.147 11.136 38.8113 9.59277 36.2432 8.54777C33.6752 7.50277 30.9256 6.97665 28.1531 6.99975C25.3825 6.97955 22.6353 7.50782 20.0697 8.55412C17.5042 9.60042 15.1711 11.1441 13.2048 13.0961C11.2385 15.0482 9.67796 17.37 8.61305 19.9279C7.54814 22.4857 6.99993 25.2291 7 27.9998V40.2498C7 41.178 7.36875 42.0682 8.02513 42.7246C8.6815 43.381 9.57174 43.7498 10.5 43.7498H14C14.9283 43.7498 15.8185 43.381 16.4749 42.7246C17.1313 42.0682 17.5 41.178 17.5 40.2498V31.4998C17.5 30.5715 17.1313 29.6813 16.4749 29.0249C15.8185 28.3685 14.9283 27.9998 14 27.9998H7'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M49.3281 40.25V45.5C49.3281 47.3565 48.5906 49.137 47.2779 50.4497C45.9651 51.7625 44.1846 52.5 42.3281 52.5H29.75'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </BaseLibraryIconSvg>
  );
}
